import { components } from "@certn/api/generated-schemas/applicant-portal";
import { createContext } from "react";

export const CustomQuestionnaireLayoutContext = createContext<{
  sectionLabel?: string;
  subLabel?: string;
  templateData?: {
    templates: readonly components["schemas"]["CustomQuestionnaireTemplate"][];
  };
  apiError?: Error;
}>({});
